import React from 'react';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import {
    resultsConfigSelector,
    browserMediaTypeSelector } from 'ctm-selectors';
import { get } from 'ctm-util-functions';
import { getExperimentID } from 'ctm-app/client/store/selectors';

import { CompareToggle } from './compare_toggle';

const _CompareToggleContainer = (props) => <CompareToggle {...props} />;

// Frequently used selectors to get data from the props passed to the component.
const getProductId = (props) => get(props, 'stateProps.product.productMeta.id');

/**
 * Use the redux store to determine if the current product is selected or disabled.
 * @param {Object} state - Redux store state.
 * @param {Object} props - Props passed to the component.
 * @return {Object} - The state attrs to add to props.
 */
export const mapStateToProps = (state, props) => {
    const breakpoint = browserMediaTypeSelector(state);
    const resultsConfig = resultsConfigSelector(state);
    const selectedProductIds = resultsConfig.getIn(['helpers', 'filters', 'selectedProductIds']) || Immutable.List();
    const displayMode = resultsConfig.get('displayMode');
    const compareModeActive = resultsConfig.get('compareModeActive') || false;
    const minProducts = resultsConfig.get('minProducts') || 2;
    const maxProducts = breakpoint !== 'xs' ? get(props, 'contentProps.maxProducts') : 2;

    return {
        ...props,
        selectedProductIds,
        displayMode,
        getProductId,
        compareModeActive,
        minProducts,
        isSelected: selectedProductIds.includes(getProductId(props)),
        isDisabled: selectedProductIds.size >= maxProducts,
        experimentID: getExperimentID(state)
    };
};

/**
 * Create function to enable user to select/deselect the product.
 * @param {function(action: Object): undefined} dispatch - Redux dispatch method.
 * @param {Object} props - Props passed to the component.
 * @return {Object} - Function to dispatch actions that are passed as props.
 */
export const mapDispatchToProps = (dispatch, props) => {
    return {
        toggleCompare: (toggle) => {
            dispatch({ type: 'TOGGLE_COMPARE_MODE', toggle });
        },
        toggleProduct: (toggle) => {
            dispatch({
                type: 'TOGGLE_COMPARED_PRODUCT',
                filterValue: getProductId(props),
                toggle
            });
        }
    };
};
const CompareToggleContainer = connect(mapStateToProps, mapDispatchToProps)(_CompareToggleContainer);

export {
    CompareToggleContainer,
    _CompareToggleContainer // for testing only
};
